export var EXPAND_COLUMN = {};
export var INTERNAL_HOOKS = 'dw-neit-rc-table-internal-hook';